/**
 * @generated SignedSource<<8bcefd34003ca18483e6e51648edd6f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotType = "BUCKET" | "MULTI" | "QUEUE" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type PreviousBookingsListClient$data = {
  readonly id?: string;
  readonly repeatableBookings?: ReadonlyArray<{
    readonly id?: string;
    readonly rounds?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly nonPlayingHost?: boolean;
          readonly player: {
            readonly fullName: string;
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly startSlot?: {
      readonly standardCapacity?: number;
      readonly type: SlotType;
      readonly usedCapacity?: number;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PreviousBookingsListItem">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PreviousBookingsListClient";
};
export type PreviousBookingsListClient$key = {
  readonly " $data"?: PreviousBookingsListClient$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreviousBookingsListClient">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dateLte",
        "variableName": "currentDate"
      },
      {
        "kind": "Variable",
        "name": "forSlotId",
        "variableName": "forSlotId"
      },
      {
        "kind": "Variable",
        "name": "slotType",
        "variableName": "slotType"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "repeatableBookings",
    "plural": true,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "startSlot",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "usedCapacity",
                    "storageKey": null
                  },
                  {
                    "alias": "standardCapacity",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "bookingType",
                        "value": "STANDARD"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "capacity",
                    "storageKey": "capacity(bookingType:\"STANDARD\")"
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoundConnection",
            "kind": "LinkedField",
            "name": "rounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nonPlayingHost",
                            "storageKey": null
                          }
                        ],
                        "type": "MemberRound",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "StandardBooking",
        "abstractKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PreviousBookingsListItem"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currentDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forSlotId"
    },
    {
      "kind": "RootArgument",
      "name": "slotType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreviousBookingsListClient",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Member",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Customer",
      "abstractKey": null
    }
  ],
  "type": "Client",
  "abstractKey": "__isClient"
};
})();

(node as any).hash = "206bf8e8a419bc28e25aeaf440a1414c";

export default node;
